import { render, staticRenderFns } from "./template-message-add.vue?vue&type=template&id=1a726b96&scoped=true&"
import script from "./template-message-add.vue?vue&type=script&lang=js&"
export * from "./template-message-add.vue?vue&type=script&lang=js&"
import style0 from "./template-message-add.vue?vue&type=style&index=0&id=1a726b96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a726b96",
  null
  
)

export default component.exports